import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';
import { Plus, Mail } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/utils/api';

export const CustomAllergenSection = () => {
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const [allergenName, setAllergenName] = useState('');
  const [keywords, setKeywords] = useState('');
  const [additives, setAdditives] = useState('');
  const [userEmail, setUserEmail] = useState('');

  const handleSuggest = async () => {
    if (!allergenName.trim()) {
      toast.error('El nombre del alérgeno es requerido');
      return;
    }

    try {
      await api.post('/suggestions/submit', {
        name: userEmail || null,
        email: userEmail || null,
        message: `SUGERENCIA DE ALÉRGENO:\n\nNombre: ${allergenName}\nPalabras clave: ${keywords}\nAditivos: ${additives}\n\nPor favor, añade este alérgeno a la base de datos.`
      });

      toast.success(t('allergenSuggestionSent'));
      toast.info('Enviaremos tu sugerencia a allergenapp.mail@gmail.com');
      
      // Clear form
      setAllergenName('');
      setKeywords('');
      setAdditives('');
      setUserEmail('');
      setShowForm(false);
    } catch (error) {
      console.error('Error sending allergen suggestion:', error);
      toast.error('Error al enviar la sugerencia');
    }
  };

  if (!showForm) {
    return (
      <Card className="border-dashed border-2 border-[#8FBC8F]">
        <CardContent className="p-6">
          <div className="text-center space-y-3">
            <Mail className="w-8 h-8 text-[#8FBC8F] mx-auto" />
            <h3 className="font-semibold text-lg">{t('suggestAllergen')}</h3>
            <p className="text-sm text-gray-600">
              {t('suggestAllergenDesc')}
            </p>
            <Button
              onClick={() => setShowForm(true)}
              variant="outline"
              className="border-[#8FBC8F] text-[#8FBC8F] hover:bg-[#8FBC8F] hover:text-white"
              data-testid="show-custom-allergen-form"
            >
              <Plus className="w-4 h-4 mr-2" />
              {t('addCustomAllergen')}
            </Button>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-[#8FBC8F]">
      <CardContent className="p-6 space-y-4">
        <h3 className="font-semibold text-lg">{t('addCustomAllergen')}</h3>
        
        <div>
          <Label htmlFor="allergen-name">{t('allergenName')} *</Label>
          <Input
            id="allergen-name"
            data-testid="custom-allergen-name"
            placeholder="Ej: Mostaza"
            value={allergenName}
            onChange={(e) => setAllergenName(e.target.value)}
          />
        </div>

        <div>
          <Label htmlFor="keywords">{t('keywords')}</Label>
          <Input
            id="keywords"
            data-testid="custom-allergen-keywords"
            placeholder="Ej: mostaza, mustard, moutarde"
            value={keywords}
            onChange={(e) => setKeywords(e.target.value)}
          />
        </div>

        <div>
          <Label htmlFor="additives">{t('customAdditives')}</Label>
          <Input
            id="additives"
            data-testid="custom-allergen-additives"
            placeholder="Ej: E270, E322"
            value={additives}
            onChange={(e) => setAdditives(e.target.value)}
          />
        </div>

        <div>
          <Label htmlFor="user-email">{t('yourEmail')} (opcional)</Label>
          <Input
            id="user-email"
            data-testid="custom-allergen-email"
            type="email"
            placeholder="tu@email.com"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
          />
        </div>

        <div className="text-xs text-gray-500 bg-amber-50 p-3 rounded">
          <strong>Nota:</strong> Tu sugerencia será enviada a allergenapp.mail@gmail.com para revisión.
          Te notificaremos cuando el alérgeno sea añadido.
        </div>

        <div className="flex gap-2">
          <Button
            onClick={handleSuggest}
            className="flex-1 bg-[#8FBC8F] hover:bg-[#7CAA7C]"
            data-testid="submit-custom-allergen"
          >
            <Mail className="w-4 h-4 mr-2" />
            {t('sendSuggestion')}
          </Button>
          <Button
            onClick={() => {
              setShowForm(false);
              setAllergenName('');
              setKeywords('');
              setAdditives('');
              setUserEmail('');
            }}
            variant="outline"
          >
            {t('close')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
